/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/core/NormalizePathSep.ts
 * @create:      2025-07-01 17:59:16.990
 * @modify:      2025-07-11 21:19:12.942
 * @version:     6.0.0
 * @times:       4
 * @lines:       68
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { ReplaceAll } from "../string/ReplaceAll";

/**
 * Normalizes the path separator in a given path string to either "/" or "\\".
 *
 * Replaces all occurrences of the opposite separator with the specified one,
 * and collapses any duplicate separators into a single instance.
 *
 * @param pathStr - The input path string to normalize.
 * @param sep - The desired path separator ("/" or "\\"). Defaults to "/".
 * @returns The normalized path string with consistent separators.
 * 
 * @since 4.0.0
 * @version 2022-08-31
 */
export function NormalizePathSep(pathStr: string, sep?: "/" | "\\") {
    if (!pathStr) {
        return pathStr;
    }

    if (sep === undefined) {
        sep = "/";
    }

    const old = sep === "/" ? "\\" : "/";

    let path = ReplaceAll(pathStr, old, sep);

    const t = sep + sep;
    while (path.includes(t)) {
        path = ReplaceAll(path, t, sep);
    }

    return path;
}
